/*
export const someGetter = (state) => {}
 */

export const currentUser = (state) => {
  return state.currentUser
}
